import { render, staticRenderFns } from "./PortfolioModal.vue?vue&type=template&id=73176a86&"
import script from "./PortfolioModal.vue?vue&type=script&lang=js&"
export * from "./PortfolioModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports